React = require 'react'
t = require('views/internal/recup-with-helpers')('home')
l = require 'lib/localize'
f = require 'effing'
Auth = require 'db/auth'
HomeSectionHeaderComponent = require 'views/home/home-section-header-component'
HomeActivityFeedActivityComponent = require 'views/home/home-activity-feed-activity-component'
HomeSectionHeaderLinkComponent = require 'views/home/home-section-header-link-component'
HomeOrientationComponent = require 'views/home/home-orientation-component'

module.exports = class HomeActivityFeedComponent extends React.Component
  displayName: 'HomeActivityFeedComponent'
  maxPageResults: 50

  constructor: (props) ->
    super props

    @trackOnClickCanonicalCard = @trackOnClickCanonicalCard.bind(@)

  trackOnClickCanonicalCard: ->
    # TODO add tracking

  render: t.renderable ->
    { actions
      loadingMore
      loadingNew
      loadMoreActivities
      onHomeTab
      memberCreator
      moreHighlightsLength
      showUnreadActions
      unreadActions
      dismissHighlightsOrientationCard
    } = @props

    t.div '.home-activity-feed.home-main-content-item', =>
      if actions.length
        linkElements = []
        if unreadActions.length
          linkElements.push {
              url: '#',
              iconClass: 'refresh',
              titleKey: 'load-new-activity',
              onClick: showUnreadActions
            }

        t.addElement React.createElement HomeSectionHeaderComponent, {
          title: if onHomeTab then l('home title.highlights') else l('home title.team highlights')
          iconClass: 'heart'
          linkElements: linkElements.map(f.choke(1, React, 'createElement', HomeSectionHeaderLinkComponent))
        }

        if !Auth.me().isDismissed('homeHighlightsOrientationCard')
          t.addElement React.createElement HomeOrientationComponent, {
            title: 'orientation-highlight-title'
            text: 'orientation-highlight-text'
            backgroundClass: 'home-orientation-highlight-background'
            onDismissClick: dismissHighlightsOrientationCard
          }

        actions.map (action) =>
          t.tag HomeActivityFeedActivityComponent, {
            key: action.id
            action
            memberCreator
            trackOnClickCanonicalCard: @trackOnClickCanonicalCard
          }

        if loadingMore
          t.div ->
            t.div '.spinner.loading'

        else if actions.length == @maxPageResults || moreHighlightsLength == @maxPageResults
          t.a '.show-more.u-text-align-center', { onClick: loadMoreActivities, href: '#' }, ->
            t.format 'show-more-activity'

      else
        t.div()



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-activity-feed-component.coffee